import React, { FC, ReactNode } from 'react';
import clsx from 'clsx';
import { useStyles } from './styles';

interface DroppableWrapperProps {
  isDraggingOver: boolean;
  isDraggingFrom: boolean;
  innerRef: any;
  className?: string;
  children: ReactNode;
}

export const DroppableWrapper: FC<DroppableWrapperProps> = ({
  isDraggingOver,
  isDraggingFrom,
  innerRef,
  children,
  className,
  ...props
}) => {
  const classes = useStyles({ isDraggingOver, isDraggingFrom });
  return (
    <div className={clsx(classes.root, className)} ref={innerRef} {...props}>
      {children}
    </div>
  );
};
